/**
 * Android platform files
 */

export {default as linkConfig} from './link';
export {default as commands} from './commands';
export {projectConfig, dependencyConfig} from './config';
export {getAndroidProject, getPackageName} from './utils/getAndroidProject';
